// This file is automatically generated by internal/scripts/refresh-assets.ts.
// Do not edit manually. Or do, I'm a comment, not a cop.

export const version = '5.3.0'
export const publishDates = {
	major: '2026-05-06T16:28:18.473Z',
	minor: '2026-08-05T11:39:54.978Z',
	patch: '2026-08-05T11:39:54.978Z',
}
